import get from 'lodash/get';
import PropTypes from 'prop-types';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import Card from '@zenbusiness/zui/Card';
import Stack from '@zenbusiness/zui/Stack';
import { useTheme } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

function ActionItem({ color = 'primary', href = '', label, onClick = () => {}, to = '', variant = 'contained' }) {
  return (
    <Button
      color={color}
      endIcon={<ArrowForwardIcon />}
      href={href}
      fullWidth
      key={label}
      onClick={onClick}
      size="sm"
      sx={{ justifyContent: 'space-between' }}
      to={to}
      variant={variant}
    >
      <FormattedMessage id={label} />
    </Button>
  );
}

ActionItem.propTypes = {
  color: PropTypes.string,
  href: PropTypes.string,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  to: PropTypes.string,
  variant: PropTypes.string,
};

function NotificationCard({ actions = [], color = 'background.blue.main', message, isRawText = false, title }) {
  const theme = useTheme();

  return (
    <Card sx={{ display: 'flex', gap: 2, padding: 2 }}>
      <Box
        sx={{
          minWidth: '0.25rem',
          alignSelf: 'stretch',
          backgroundColor: get(theme.palette, color),
          borderRadius: 1,
        }}
      />
      <Stack flex={1} spacing={0.5}>
        {title && (
          <Text size="sm" weight="medium">
            {isRawText ? title : <FormattedMessage id={title} />}
          </Text>
        )}
        <Stack spacing={1.5}>
          {message && (
            <Text size="sm" sx={{ whiteSpace: 'pre-line' }}>
              {isRawText ? message : <FormattedMessage id={message} />}
            </Text>
          )}
          {actions.map((action) => (
            <ActionItem key={action.label} {...action} />
          ))}
        </Stack>
      </Stack>
    </Card>
  );
}

NotificationCard.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.shape(ActionItem.propTypes)),
  color: PropTypes.string,
  message: PropTypes.string,
  isRawText: PropTypes.bool,
  title: PropTypes.string,
};

export default NotificationCard;
